export default {
    prompts: state => state.prompts
}